// extracted by mini-css-extract-plugin
export var actions = "_s5-4";
export var item = "_s5-1";
export var price = "_s5-3";
export var quantity = "_s5-2";
export var table = "_s5-0";